import { useCallback } from 'react';

import type { VariantType } from 'notistack';
import { useSnackbar as useBaseSnackBar } from 'notistack';

import useId from '../../hooks/use-id/use-id';

export const useSnackBar = () => {
  const { getId } = useId('snackbar');
  const { enqueueSnackbar, closeSnackbar } = useBaseSnackBar();

  const notify = useCallback(
    (message: string, variant: VariantType) => {
      const key = getId();
      enqueueSnackbar(message, {
        key,
        variant,
        onClick: () => {
          closeSnackbar(key);
        },
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
      });
    },
    [closeSnackbar, enqueueSnackbar, getId]
  );

  const notifySuccess = useCallback(
    (message: string) => {
      notify(message, 'success');
    },
    [notify]
  );

  const notifyWarning = useCallback(
    (message: string) => {
      notify(message, 'warning');
    },
    [notify]
  );

  const notifyError = useCallback(
    (message: string) => {
      notify(message, 'error');
    },
    [notify]
  );

  return {
    notifySuccess,
    notifyWarning,
    notifyError,
  };
};

export default useSnackBar;
